import { booleanAttribute, Component, input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'preloader',
  templateUrl: './preloader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./preloader.component.scss']
})
export class PreloaderComponent implements OnInit {

  hasOverlay = input<boolean, boolean | string>(false, { transform: booleanAttribute });
  position = input<'absolute-center' | 'default'>('default');

  constructor() { }

  ngOnInit(): void {
  }

}
